import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import SellsyAIInput from '../customoptions/SellsyAIInput.vue';

export default Node.create({
    name: 'SellsyAIInput',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            isLoading: {
                default: false,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'SellsyAIInput',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['SellsyAIInput', mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(SellsyAIInput);
    },
});
